import type { UserStatus } from '@olmt/shared'

const STATUS_STYLES: Record<UserStatus, string> = {
  pending: 'bg-warn/12 text-warn ring-warn/30',
  approved: 'bg-accent/12 text-accent ring-accent/30',
  rejected: 'bg-danger/12 text-danger ring-danger/30',
  suspended: 'bg-surface2 text-muted ring-line-strong',
}

/** The four states of §11, as a word and a tint — never a colour alone. */
export function StatusPill({ status }: { status: UserStatus }) {
  return (
    <span
      className={`shrink-0 rounded-full px-2 py-0.5 text-meta font-medium ring-1 ring-inset ${STATUS_STYLES[status]}`}
    >
      {status}
    </span>
  )
}
